import { usePathname } from "@/hooks/use-pathname";
import classNames from "classnames";
import React from "react";
import { useNavigate } from "react-router";

const NavMenu: React.FC<NavItemsProps> = ({ navs }) => {
  const navigate = useNavigate();
  const { pathname } = usePathname();
  const onClick = (path: string) => {
    navigate(path);
  };

  const isActiveRoute = (navPath: string) => {
    if (navPath === "/") {
      return pathname === "/";
    }
    return pathname === navPath || pathname.startsWith(navPath + "/");
  };

  return (
    <ul className="flex flex-row items-center gap-x-6 sm:gap-x-8 lg:gap-x-8 xl:gap-x-12 max-lg:hidden">
      {navs?.map((nav: NavItem, index: number) => {
        return (
          <li
            role="button"
            aria-label="Nav Item"
            onClick={() => onClick(nav.path)}
            key={nav.path + index}
            className={classNames(
              " text-sm font-redhat-display font-bold cursor-pointer transition-all duration-300 hover:text-white/60 relative top-0 active:top-px",
              isActiveRoute(nav.path) ? "text-primary-1" : "text-white",
            )}
          >
            {nav.label}
          </li>
        );
      })}
    </ul>
  );
};

export default NavMenu;
